import { PromoFormValues } from 'types/promotion/promotionTypes';

export const initialValues = (data: PromoFormValues | null) => {
  if (data && Object.keys(data).length > 0) {
    return {
      promoName: data.promoName || '',
      branch: data.branch || [],
      promoType: data.promoType || '',
      DiscountType: data.DiscountType || '1',
      ConditionType: data.ConditionType || '1',
      notLimitDate: data.notLimitDate || '1',
      promoPeriod: {
        dateRange: {
          start: data.promoPeriod?.dateRange.start || '',
          end: data.promoPeriod?.dateRange.end || '',
        },
        timeRange: {
          start: data.promoPeriod?.timeRange.start || '00:00',
          end: data.promoPeriod?.timeRange.end || '23:59',
        },
        days: {
          sun: data.promoPeriod?.days.sun || false,
          mon: data.promoPeriod?.days.mon || false,
          tue: data.promoPeriod?.days.tue || false,
          wed: data.promoPeriod?.days.wed || false,
          thu: data.promoPeriod?.days.thu || false,
          fri: data.promoPeriod?.days.fri || false,
          sat: data.promoPeriod?.days.sat || false,
        },
      },
      promoProducts: {
        lists: data.promoProducts?.lists || [],
        info: data.promoProducts?.info || [],
      },
      promoDiscount: Array.isArray(data.promoDiscount)
        ? data.promoDiscount
        : [
            {
              qty: '',
              discount: '',
            },
          ],
      // promoFreeGift: Array.isArray(data.promoFreeGift)
      //   ? data.promoFreeGift
      //   : [],
      promoFreeGift:
        typeof data.promoFreeGift === 'object' && data.promoFreeGift !== null
          ? data.promoFreeGift
          : {
              conditionType: '1',
              thresholdValue: '',
              freeType: '1',
              freeQty: '',
              freeList: [],
            },
      usage_limit: data.usage_limit || '',
      isActive: data.isActive || '0',
    };
  } else {
    return {
      promoName: '',
      branch: [],
      promoType: '',
      notLimitDate: '1',
      DiscountType: '1',
      ConditionType: '1',
      promoPeriod: {
        dateRange: {
          start: '',
          end: '',
        },
        timeRange: {
          start: '00:00',
          end: '23:59',
        },
        days: {
          sun: false,
          mon: false,
          tue: false,
          wed: false,
          thu: false,
          fri: false,
          sat: false,
        },
      },
      promoProducts: {
        lists: [],
        info: [],
      },
      promoDiscount: [
        {
          qty: '',
          discount: '',
        },
      ],
      promoFreeGift: {
        conditionType: '1',
        thresholdValue: '',
        freeType: '1',
        freeQty: '',
        freeList: [],
      },
      usage_limit: '0',
      isActive: '1',
    };
  }
};
